module.exports = __webpack_public_path__ + "img/presse-foire-europeene-de-strasbourg.bed6948d.jpg";